import React from 'react';
import { useDashboard } from '../../context/DashboardContext';
import KPICard from '../ui/KPICard';

const KPISection = () => {
  const { kpis, loading } = useDashboard();

  // Format currency (Japanese Yen)
  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '¥0';
    return `¥${Math.round(value).toLocaleString()}`;
  };

  // Format percentage
  const formatPercent = (value) => {
    if (value === null || value === undefined) return '0%';
    return `${Math.round(value)}%`;
  };

  // TODO: These targets should come from database/settings later
  // For now, using placeholder targets
  const salesTarget = 800000;
  const nominationTarget = 50;

  // Calculate achievement rates
  const totalSales = kpis?.total_sales || 0;
  const nominationRate = kpis?.nomination_rate || 0;
  
  const salesAchievement = salesTarget > 0 
    ? Math.round((totalSales / salesTarget) * 100) 
    : 0;
  
  const nominationAchievement = nominationTarget > 0 
    ? Math.round((nominationRate / nominationTarget) * 100) 
    : 0;

  if (loading.kpis) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-5 mb-4">
        <div className="bg-white rounded-lg p-3 md:p-6 animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-20 mb-4"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
        </div>
        <div className="bg-white rounded-lg p-3 md:p-6 animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-20 mb-4"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-5 mb-4">
      <KPICard 
        title="総売上"
        value={formatCurrency(totalSales)}
        target={formatCurrency(salesTarget)}
        achievementRate={`${salesAchievement}%`}
      />
      <KPICard 
        title="指名率"
        value={formatPercent(nominationRate)}
        target={formatPercent(nominationTarget)}
        achievementRate={`${nominationAchievement}%`}
      />
    </div>
  );
};

export default KPISection;
